import { getTvObject, tv } from '@costar-ui/cosmos';
import radiusOptions from '../../common/radius-options/radius-options.esm.js';

var baseTV = getTvObject({
  variants: {
    fit: {
      contain: 'object-contain',
      cover: 'object-cover',
      fill: 'object-fill',
      none: 'object-none',
      'scale-down': 'object-scale-down'
    },
    radius: radiusOptions.radius
  }
});
var captionTV = getTvObject({
  base: ['w-full', 'text-p-16', 'text-center', 'p-2', 'absolute', 'bottom-0', 'backdrop-blur-sm'],
  variants: {
    mode: {
      light: ['bg-neutral/75', 'text-on-neutral'],
      dark: ['bg-neutral-strong/50', 'text-on-neutral-strong']
    }
  }
});
var wrapperTV = getTvObject({
  base: ['relative']
});
var base = {
  base: tv(baseTV),
  caption: tv(captionTV),
  wrapper: tv(wrapperTV)
};
var imageStyles = {
  base: base
};

export { baseTV, captionTV, imageStyles };
//# sourceMappingURL=image.styles.esm.js.map
